module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 540
// module chunks = 